import i18n from '@/dependencies/i18n';

const { t } = i18n.global;

export default {
    path: '/organization/:organizationId',
    component: () => import('../views/Client/ClientOrganizationView.vue'),
    meta: {
        private: true,
        breadcrumb: {
            parent: 'dashboard',
        },
    },
    children: [
        {
            path: '',
            name: 'organization',
            component: () => import('@/components/Client/Organization/Organization.vue'),
            meta: {
                breadcrumb() {
                    return {
                        label: t('SIDEBAR_MENU.OVERVIEW'),
                    };
                },
            },
        },
        {
            path: 'organization-documents',
            name: 'organization-documents',
            component: () => import('@/components/Client/Organization/views/OrganizationDocuments/OrganizationDocuments.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.DOCUMENTS') }),
            },
        },
        {
            path: 'organization-passport',
            name: 'organization-passport',
            component: () => import('@/components/Client/Organization/views/OrganizationPassport/OrganizationPassport.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.PASSPORT') }),
            },
        },
        {
            path: 'organization-contracts',
            name: 'organization-contracts',
            component: () => import('@/components/Client/Organization/views/OrganizationContracts/OrganizationContracts.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.CONTRACT') }),
            },
        },
        {
            path: 'organization-jobs',
            name: 'organization-jobs',
            component: () => import('@/components/Client/Organization/views/OrganizationJobs/OrganizationJobs.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.JOBS') }),
            },
        },
    ],
};
